import {memo, SVGAttributes, useMemo} from 'react';

export type IconProps = SVGAttributes<SVGElement> & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  svg: any;
  size?: number;
  className?: string;
};

export const Icon = memo(
  ({svg: Component, size, className, ...otherProps}: IconProps) => {
    const svgProps: SVGAttributes<SVGElement> = useMemo(
      () => ({
        ...(size && {
          width: size,
          height: size,
          viewBox: `0 0 ${size} ${size}`,
        }),
        'aria-hidden': 'true',
      }),
      [size],
    );

    return <Component className={className} {...svgProps} {...otherProps} />;
  },
);

Icon.displayName = 'Icon';
